<template>
  <form class="quick-category" @submit.prevent="onSubmit">
    <div class="quick-category__grid">
      <div class="quick-category__field">
        <label>نام برند</label>
        <input v-model="form.name" type="text" class="form-control" placeholder="نام برند" @input="syncSlug">
      </div>
      <div class="quick-category__field">
        <label>slug</label>
        <input v-model="form.slug" type="text" class="form-control" placeholder="slug">
      </div>
      <div class="quick-category__field">
        <label>زبان</label>
        <select class="form-control custom-select" v-model="form.language_id">
          <option value="">انتخاب زبان</option>
          <option v-for="language in languages" :key="language.id" :value="language.id">
            {{ language.name }}
          </option>
        </select>
      </div>
      <div class="quick-category__field">
        <label>توضیحات</label>
        <input v-model="form.description" type="text" class="form-control" placeholder="توضیحات (اختیاری)">
      </div>
    </div>

    <div class="quick-category__actions">
      <button type="submit" class="quick-category__submit" :disabled="loading">
        {{ loading ? 'در حال ثبت...' : 'ثبت برند' }}
      </button>
    </div>
  </form>
</template>

<script>
import {mapGetters} from 'vuex'
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";

export default {
  name: "QuickBrandCreate",
  data() {
    return {
      loading: false,
      form: {
        name: '',
        slug: '',
        description: '',
        language_id: '',
        image: [],
        noRedirect: true,
      }
    }
  },
  computed: {
    ...mapGetters({
      languages: "Language/getLanguages",
    }),
  },
  methods: {
    syncSlug() {
      if (!this.form.name) {
        this.form.slug = ''
        return
      }
      let link = this.form.name.toLowerCase()
      link = link.replace(/ +/g, "-")
      link = link.replace(/[^\wآابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهی]+/g, "-")
      this.form.slug = link
    },
    async onSubmit() {
      if (!this.form.name || !this.form.slug || !this.form.language_id) {
        toast('خطا', 'نام، slug و زبان الزامی است.')
        return
      }
      this.loading = true
      try {
        await this.$store.dispatch('Brand/createBrand', {...this.form, noRedirect: true})
        await this.$store.dispatch('Brand/getBrands')
        this.$emit('created')
        this.form.name = ''
        this.form.slug = ''
        this.form.description = ''
      } catch (e) {
        console.log(e)
      } finally {
        this.loading = false
      }
    }
  },
  mounted() {
    const defaultLanguage = findAttributeOnSiteInfo('default_language')
    if (defaultLanguage && defaultLanguage[0]) {
      this.form.language_id = defaultLanguage[0].id
    }
  }
}
</script>

<style scoped>
.quick-category {
  display: grid;
  gap: 1rem;
}

.quick-category__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.85rem;
}

.quick-category__field label {
  display: block;
  margin-bottom: 0.4rem;
  font-weight: 700;
  color: #424242;
}

.quick-category__field .form-control,
.quick-category__field .custom-select {
  border-radius: 12px;
}

.quick-category__actions {
  display: flex;
  justify-content: flex-end;
}

.quick-category__submit {
  min-height: 44px;
  padding: 0 1.4rem;
  border: 0;
  border-radius: 999px;
  background: var(--primary, #eb3d60);
  color: #fff;
  font-weight: 800;
  cursor: pointer;
}

.quick-category__submit:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

@media (max-width: 767.98px) {
  .quick-category__grid {
    grid-template-columns: 1fr;
  }
}
</style>
